"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const account_1 = require("./types/account");
const agreements_1 = require("./types/agreements");
const applications_1 = require("./types/applications");
const cards_1 = require("./types/cards");
const notifications_1 = require("./types/notifications");
const rewards_1 = require("./types/rewards");
const transactions_1 = require("./types/transactions");
const user_1 = require("./types/user");
const vgs_1 = require("./types/vgs");
const apiClientBase_1 = require("./apiClientBase");
/**
 * `ApiClient` is a encapsulation of the network request logic needed to interact with the backend
 * as an authenticated user. It's intended to be as stateless as possible to simplify testing (it
 * only receives a reference to an `AxiosInstance`, which we can mock out later to create a
 * `MockApiClient` for testing).
 */
class ApiClient extends apiClientBase_1.ApiClientBase {
    /**
     * ====================================================
     * ACCOUNT ENDPOINTS
     * ====================================================
     */
    addBankAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.AddBankAccount, args);
            return resp.data;
        });
    }
    addPendingBankAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.AddPendingBankAccount, args);
            return resp.data;
        });
    }
    cancelPayment(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(account_1.AccountEndpoints.CancelPayment, args);
        });
    }
    deleteBankAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(account_1.AccountEndpoints.DeleteBankAccount, args);
        });
    }
    deletePendingBankAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(account_1.AccountEndpoints.DeletePendingBankAccount, args);
        });
    }
    getAccountSummaries(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetAccountSummaries, args);
            return resp.data;
        });
    }
    getBankAccounts(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetBankAccounts, args);
            return resp.data;
        });
    }
    getPlaidLinkToken(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetPlaidLinkToken, args);
            return resp.data;
        });
    }
    getScheduledPaymentsByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetScheduledPaymentsByAccount, args);
            return resp.data;
        });
    }
    getScheduledPaymentsByUser(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetScheduledPaymentsByUser, args);
            return resp.data;
        });
    }
    getStatements(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetStatements, args);
            return resp.data;
        });
    }
    getStatementUrl(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetStatementUrl, args);
            return resp.data;
        });
    }
    // TODO: remove these two and their corresponding request/response
    exportTransactions(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.ExportTransactions, args);
            return resp.data;
        });
    }
    createDispute(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.CreateDispute, args);
            return resp.data;
        });
    }
    getTransactionsExportedUrl(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.GetTransactionsExportedURL, args);
            return resp.data;
        });
    }
    getExportedStatementUrl(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.GetExportedStatementUrl, args);
            return resp.data;
        });
    }
    schedulePayment(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.SchedulePayment, args);
            return resp.data;
        });
    }
    updateScheduledPayment(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(account_1.AccountEndpoints.UpdateScheduledPayment, args);
            return resp.data;
        });
    }
    /**
     * ====================================================
     * AGREEMENTS ENDPOINTS
     * ====================================================
     */
    acknowledgeAgreement(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(agreements_1.AgreementsEndpoints.AcknowledgeAgreement, args);
        });
    }
    getAgreementsToAcknowledge(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(agreements_1.AgreementsEndpoints.GetAgreementsToAcknowledge, args);
            return resp.data;
        });
    }
    getApplicationAgreements(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(agreements_1.AgreementsEndpoints.GetApplicationAgreements, args);
            return resp.data;
        });
    }
    getStaticDisclosures() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(agreements_1.AgreementsEndpoints.GetStaticDisclosures);
            return resp.data;
        });
    }
    /**
     * ====================================================
     * APPLICATIONS ENDPOINTS
     * ====================================================
     */
    checkWaitlist(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.CheckWaitlist, args);
            return resp.data;
        });
    }
    deleteApplication(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(applications_1.ApplicationsEndpoints.DeleteApplication, args);
        });
    }
    getApplicationStatus(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.GetApplicationStatus, args);
            return resp.data;
        });
    }
    getApprovalOffers(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.GetApprovalOffers, args);
            return resp.data;
        });
    }
    getPlaidIdentityLinkToken(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.GetPlaidIdentityLinkToken, args);
            return resp.data;
        });
    }
    prefillPartnerApplication(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.PrefillPartnerApplication, args);
            return resp.data;
        });
    }
    getProductLaunchStatus(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.GetProductLaunchStatus, args);
            return resp.data;
        });
    }
    manageOffer(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.ManageOffer, args);
            return resp.data;
        });
    }
    ssn4ToSsn9(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.Ssn4ToSsn9, args);
            return resp.data;
        });
    }
    shouldVerifyPhone(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.ShouldVerifyPhone, args);
            return resp.data;
        });
    }
    submitApplication(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.SubmitApplication, args, { baseURL: this.vgsBaseUrl });
            return resp.data;
        });
    }
    submitIdentityVerification(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.SubmitIdentityVerification, args);
            return resp.data;
        });
    }
    verifyPrescreenedIdentity(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(applications_1.ApplicationsEndpoints.VerifyPrescreenedIdentity, args);
            return resp.data;
        });
    }
    /**
     * ====================================================
     * CARD ENDPOINTS
     * ====================================================
     */
    activateCardLoggedIn(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(cards_1.CardEndpoints.ActivateCardLoggedIn, args);
        });
    }
    createPaymentAuthCode(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(cards_1.CardEndpoints.CreatePaymentAuthCode, args);
            return resp.data;
        });
    }
    getCardSummaries(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(cards_1.CardEndpoints.GetCardSummaries, args);
            return resp.data;
        });
    }
    changeCardPin(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.post(cards_1.CardEndpoints.ChangeCardPin, args);
            return res.data;
        });
    }
    getPushProvisioningData(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(cards_1.CardEndpoints.GetPushProvisioningData, args);
            return resp.data;
        });
    }
    replaceCard(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(cards_1.CardEndpoints.ReplaceCard, args);
            return resp.data;
        });
    }
    updateCardStatus(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(cards_1.CardEndpoints.UpdateCardStatus, args);
        });
    }
    /**
     * ====================================================
     * NOTIFICATIONS ENDPOINTS
     * ====================================================
     */
    togglePushNotifications(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(notifications_1.NotificationsEndpoints.TogglePushNotifications, args);
        });
    }
    /**
     * ====================================================
     * REWARDS ENDPOINTS
     * ====================================================
     */
    checkIfUserExistsOnPartner(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.CheckIfUserExistsOnPartner, args);
            return resp.data;
        });
    }
    claimBenefit(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.ClaimBenefit, args);
            return resp.data;
        });
    }
    completeExternalOauthLogin(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.CompleteExternalOauthLogin, args);
            return resp.data;
        });
    }
    getBenefitsByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetBenefitsByAccount, args);
            return resp.data;
        });
    }
    getBenefitDetails(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetBenefitDetails, args);
            return resp.data;
        });
    }
    getBrandShopByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetBrandShopByAccount, args);
            return resp.data;
        });
    }
    getEarningRatesByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetEarningRatesByAccount, args);
            return resp.data;
        });
    }
    getEligibleCharitiesForRedemption(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetEligibleCharitiesForRedemption, args);
            return resp.data;
        });
    }
    getExternalLoginUrl(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetExternalLoginUrl, args);
            return resp.data;
        });
    }
    getGiftCardCatalog(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetGiftCardCatalog, args);
            return resp.data;
        });
    }
    getProductMarketingVariant(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetProductMarketingVariant, args);
            return resp.data;
        });
    }
    getProductMarketingVariantByBrand(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetProductMarketingVariantByBrand, args);
            return resp.data;
        });
    }
    getPurchasedGiftCardForAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetPurchasedGiftCardForAccount, args);
            return resp.data;
        });
    }
    getPurchasedGiftCardsForAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetPurchasedGiftCardsForAccount, args);
            return resp.data;
        });
    }
    getHistoricalGoalsByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetHistoricalGoalsByAccount, args);
            return resp.data;
        });
    }
    getHistoricalGoalsByUser(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetHistoricalGoalsByUser, args);
            return resp.data;
        });
    }
    getPointsEntriesByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetPointsEntriesByAccount, args);
            return resp.data;
        });
    }
    getPointsEntriesByEvent(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetPointsEntriesByEvent, args);
            return resp.data;
        });
    }
    getPointsMultiplierDetails(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetPointsMultiplierDetails, args);
            return resp.data;
        });
    }
    getRedemptionRatesByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetRedemptionRatesByAccount, args);
            return resp.data;
        });
    }
    getReferralInfoByAccount(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetReferralInfoByAccount, args);
            return resp.data;
        });
    }
    getTransferRatesForRedemption(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.GetTransferRatesForRedemption, args);
            return resp.data;
        });
    }
    purchaseGiftCardFromCatalog(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.PurchaseGiftCardFromCatalog, args);
            return resp.data;
        });
    }
    redeemPointsForBrandShopPurchase(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.RedeemPointsForBrandShopPurchase, args);
            return resp.data;
        });
    }
    redeemPointsForCharity(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.RedeemPointsForCharity, args);
            return resp.data;
        });
    }
    redeemPointsForGiftCard(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.RedeemPointsForGiftCard, args);
            return resp.data;
        });
    }
    redeemPointsForStatementCredit(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(rewards_1.RewardsEndpoints.RedeemPointsForStatementCredit, args);
            return resp.data;
        });
    }
    /**
     * ====================================================
     * TRANSACTIONS ENDPOINTS
     * ====================================================
     */
    getNotificationSettings(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.GetNotificationSettings, args);
            return resp.data;
        });
    }
    getTransactionById(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.GetTransactionById, args);
            return resp.data;
        });
    }
    getTransactions(args) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const resp = yield this.client.post(transactions_1.TransactionsEndpoints.GetTransactions, Object.assign(Object.assign({}, args), { pageSize: (_a = args.pageSize) !== null && _a !== void 0 ? _a : 20 }));
            return resp.data;
        });
    }
    updateNotificationSettings(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(transactions_1.TransactionsEndpoints.UpdateNotificationSettings, args);
        });
    }
    /**
     * ====================================================
     * USER ENDPOINTS
     * ====================================================
     */
    createPassword(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.CreatePassword, args);
            return resp.data;
        });
    }
    createPasswordFromToken(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.CreatePasswordFromToken, args);
            return resp.data;
        });
    }
    forgotPassword(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(user_1.UserEndpoints.ForgotPassword, args);
        });
    }
    getUser(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.GetUser, args);
            return resp.data;
        });
    }
    getPartnerUserState(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.GetPartnerUserState, args);
            return resp.data;
        });
    }
    logout(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(user_1.UserEndpoints.Logout, args);
        });
    }
    preVerifyBirthdate(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.PreVerifyBirthdate, args);
            return resp.data;
        });
    }
    preVerifyCreatePassword(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.PreVerifyCreatePassword, args);
            return resp.data;
        });
    }
    preVerifyMfaCode(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.PreVerifyMfaCode, args);
            return resp.data;
        });
    }
    resetPassword(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(user_1.UserEndpoints.ResetPassword, args);
        });
    }
    getAuthCode(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.GetAuthCode, args);
            return resp.data;
        });
    }
    sendEmailVerification(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.post(user_1.UserEndpoints.SendEmailVerification, args);
        });
    }
    sendMfaCode(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(user_1.UserEndpoints.SendMfaCode, args);
            return resp.data;
        });
    }
    /**
     * ====================================================
     * VGS ENDPOINTS
     * ====================================================
     */
    getSensitiveCardInfo(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(vgs_1.VGSEndpoints.GetSensitiveCardInfo, args, { baseURL: this.vgsBaseUrl });
            return resp.data;
        });
    }
    getSensitiveCardInfoAfterApproval(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(vgs_1.VGSEndpoints.GetSensitiveCardInfoAfterApproval, args, { baseURL: this.vgsBaseUrl });
            return resp.data;
        });
    }
}
exports.ApiClient = ApiClient;
